import { useMemo } from 'react'
import { useReducedMotion } from 'framer-motion'
import { buildMenuPages } from '@/content/printMenu/buildMenuPages'
import { MenuBookletScroll } from '@/components/printMenu/MenuBookletScroll'
import { MenuFlipBook } from '@/components/printMenu/MenuFlipBook'
import { MenuPrintStack } from '@/components/printMenu/MenuPrintStack'
import { useServicesCatalog } from '@/hooks/useFoundationData'

export function PrintMenuBook() {
  const reducedMotion = useReducedMotion()
  const catalogQuery = useServicesCatalog()
  const pages = useMemo(
    () => (catalogQuery.data ? buildMenuPages(catalogQuery.data) : []),
    [catalogQuery.data],
  )
  const totalPages = pages.length

  if (catalogQuery.isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center font-medium text-muted">
        Loading menu…
      </div>
    )
  }

  if (catalogQuery.isError || totalPages === 0) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center px-6 text-center font-medium text-muted">
        Unable to load the print menu. Check your connection or try again later.
      </div>
    )
  }

  return (
    <>
      <div className="print-menu-screen">
        {reducedMotion ? (
          <MenuBookletScroll pages={pages} totalPages={totalPages} />
        ) : (
          <MenuFlipBook pages={pages} totalPages={totalPages} />
        )}
      </div>
      <MenuPrintStack pages={pages} totalPages={totalPages} />
    </>
  )
}
